import { render } from "./c-footer.vue?vue&type=template&id=3cb200f4"
import script from "./c-footer.vue?vue&type=script&lang=js"
export * from "./c-footer.vue?vue&type=script&lang=js"

import "./c-footer.vue?vue&type=style&index=0&id=3cb200f4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__